import React from 'react'
import { useValues } from 'kea'

import I18n from 'lib/i18n'
import range from 'lib/utils/range'

import courseLogic from '~/scenes/course/show/logic'

const DAY_LABELS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
const DAYS = [1, 2, 3, 4, 5, 6, 0]
const HOURS = range(0, 23)

const Availability = () => {
  const { course } = useValues(courseLogic)
  const { bookingUrlIsAgenda, bookingUrl, availability } = course
  const table = availability.split('|').map(availability => availability.split(','))

  const handleClick = event => {
    if (bookingUrlIsAgenda) {
      window.location.href = bookingUrl
    } else {
      const timeClass = event.target.className.split(' ').filter(classNamePart => classNamePart.match(/^xx_/))[0]
      const [, day, hour] = timeClass.split('_').map(i => parseInt(i))
      let date = new Date()
      const nowHour = date.getHours()
      const nowDay = date.getDay()
      const inPast = day < nowDay || (day === nowDay && hour <= nowHour)
      date.setDate(date.getDate() + (day - nowDay) + (inPast ? 7 : 0))
      date.setHours(hour)
      date.setMinutes(0)
      date.setSeconds(0)
      date.setMilliseconds(0)
      const dayString = `${date.getYear() + 1900}-${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}-${
        date.getDate() < 10 ? '0' : ''
      }${date.getDate()}`
      const hourString = `${dayString}+${hour}`
      window.location.href = `${bookingUrl}&hour=${hourString}`
    }
  }

  return (
    <div>
      <table className='highlight weekhours'>
        <tbody>
          <tr className='day-names'>
            <th />
            {DAYS.map(day => (
              <th key={day} className='cell'>
                {I18n.t(`weekday_short.${DAY_LABELS[day]}`)}
              </th>
            ))}
          </tr>
          {HOURS.map(hour => (
            <tr key={hour}>
              <td className='hour'>{hour}</td>
              {DAYS.map(day => (
                <td
                  key={day}
                  className={`cell wh_${day}_${hour} availability-type-${table[day][hour]} ${
                    table[day][hour] > 0 ? 'available' : 'busy'
                  }`}
                >
                  <div className='nobr'>
                    <span className={`cell-1 xx_${day}_${hour}`} onClick={handleClick}>
                      &nbsp;
                    </span>
                    <span className={`cell-2 xx_${day}_${hour}`} onClick={handleClick}>
                      &nbsp;
                    </span>
                    {table[day][hour] > 0 && (
                      <span className='hint-data simple'>
                        {I18n.t(`weekday_long.${DAY_LABELS[day]}`)} {I18n.t('snippets.week_hours.at')} {`${hour}:00`}
                      </span>
                    )}
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Availability
